import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { useNavigate, useLocation } from 'react-router-dom';

export const AuthModal = ({ show, onHide, title = 'Continue Learning', actionText = 'access this feature' }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleCreateAccount = () => {
    onHide();
    navigate('/signup', { state: { from: location.pathname } });
  };

  const handleLogin = () => {
    onHide();
    navigate('/login', { state: { from: location.pathname } });
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      className="auth-prompt-modal border-0"
      dialogClassName="modal-dialog-centered"
      style={{ backdropFilter: 'blur(4px)' }}
    >
      <Modal.Header closeButton className="border-0 pb-0">
        <div className="d-flex align-items-center gap-2">
          <div className="rounded-circle bg-purple bg-opacity-10 p-2 d-flex align-items-center justify-content-center" style={{ width: '40px', height: '40px' }}>
            <i className="bi bi-lock-fill text-purple fs-5"></i>
          </div>
          <Modal.Title className="fw-bold text-navy fs-5">{title}</Modal.Title>
        </div>
      </Modal.Header>

      <Modal.Body className="px-4 py-3">
        <p className="text-gray-700 text-sm mb-3">
          To {actionText}, please create an account or sign in to your existing YooSpeak profile.
        </p>

        <div className="bg-light rounded-4 p-3 mb-3 border border-light-subtle">
          <div className="fw-bold text-navy text-sm mb-2 d-flex align-items-center gap-2">
            <i className="bi bi-stars text-warning"></i>
            Create your free YooSpeak account to:
          </div>
          <ul className="list-unstyled mb-0 text-xs text-gray-700 d-flex flex-column gap-2 ps-1">
            <li className="d-flex align-items-center gap-2">
              <i className="bi bi-check-circle-fill text-success"></i>
              <span>Join live classes with certified instructors</span>
            </li>
            <li className="d-flex align-items-center gap-2">
              <i className="bi bi-check-circle-fill text-success"></i>
              <span>Enroll in full interactive courses &amp; curriculum</span>
            </li>
            <li className="d-flex align-items-center gap-2">
              <i className="bi bi-check-circle-fill text-success"></i>
              <span>Track your learning progress &amp; completed lessons</span>
            </li>
            <li className="d-flex align-items-center gap-2">
              <i className="bi bi-check-circle-fill text-success"></i>
              <span>Download learning materials &amp; workbooks</span>
            </li>
            <li className="d-flex align-items-center gap-2">
              <i className="bi bi-check-circle-fill text-success"></i>
              <span>Earn official certificates of completion</span>
            </li>
          </ul>
        </div>
      </Modal.Body>

      <Modal.Footer className="border-0 pt-0 px-4 pb-4 d-flex flex-column gap-2 align-items-stretch">
        <Button
          variant="purple"
          className="w-100 rounded-pill fw-bold py-2 shadow-sm"
          onClick={handleCreateAccount}
        >
          Create Account
        </Button>
        <Button
          variant="outline-purple"
          className="w-100 rounded-pill fw-bold py-2"
          onClick={handleLogin}
        >
          Login
        </Button>
        <Button
          variant="link"
          className="text-muted text-decoration-none text-xs text-center mt-1 p-0"
          onClick={onHide}
        >
          Maybe Later
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default AuthModal;
